import React, { useState, useEffect } from 'react'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import './_Progress.scss'
import 'react-circular-progressbar/dist/styles.css'
import VisibilitySensor from 'react-visibility-sensor'

type ProgressProps = {
	content: JSX.Element[]
}

function Progress(props: ProgressProps) {
	const [step, setStep] = useState(0)
	const [counting, setCounting] = useState(false)
	const contentLength = props.content.length
	const increment = 100 / (contentLength - 1)

	useEffect(() => {
		const interval = setInterval(() => {
			if (step >= contentLength - 1) {
				setCounting(false)
				clearInterval(interval)
				return
			}
			if (counting) {
				setStep((prevTime) => prevTime + 1)
			}
		}, 2000)
		return () => clearInterval(interval)
	}, [step, contentLength, counting])

	function goAgain() {
		if (step === contentLength - 1) {
			setCounting(true)
			setStep(0)
		}
	}

	const percent = step * increment

	return (
		<div className="progressContainer">
			<VisibilitySensor
				onChange={(e) => {
					setCounting(e)
				}}
			>
				<CircularProgressbar
					value={percent}
					strokeWidth={2}
					maxValue={100}
					styles={buildStyles({
						pathColor: 'black',
						trailColor: '#ededed',
						pathTransition: percent === 0 ? 'none' : 'stroke-dashoffset 0.5s ease 0s',
					})}
				/>
			</VisibilitySensor>
			<div className="content">{props.content[step]}</div>
			<span className={'again ' + (step === contentLength - 1 ? 'visible' : '')} onClick={goAgain}>
				↺
			</span>
		</div>
	)
}

export default Progress
